import { ERRORS_MESSAGE } from "@lhd/constants";
import { Checkbox, Form, Input, InputNumber, Radio } from "antd";
import { FC } from "react";

const linkOptions = [
  { label: "URL", value: "url" },
  { label: "電話番号", value: "phone_number" },
  { label: "メールアドレス", value: "email" },
];

type PropsType = {
  getFieldClassName?: (name: string) => string;
};

const LinkSetting: FC<PropsType> = ({ getFieldClassName }) => {
  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_required_field"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Form.Item valuePropName="checked" name="is_prohibit_duplicate_values">
        <Checkbox>重複値を禁止する</Checkbox>
      </Form.Item>
      <Form.Item
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        label="タイプ"
        name={["item_config_data", "link_type"]}
      >
        <Radio.Group options={linkOptions} />
      </Form.Item>
      <div style={{ display: "flex" }}>
        <Form.Item
          label="価値の限界（最小）"
          name={["item_config_data", "min_num_char"]}
        >
          <InputNumber />
        </Form.Item>
        <Form.Item
          style={{ marginLeft: "2rem" }}
          label="価値の限界（最大）"
          name={["item_config_data", "max_num_char"]}
        >
          <InputNumber />
        </Form.Item>
      </div>
      <Form.Item label="初期値" name="default_value">
        <Input />
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default LinkSetting;
